<template>
  <v-card class="mb-4">

    <!-- pagination toolbar -->
    <v-row class="align-center pl-4 pr-2 pt-2 pb-2">

      <transition
      name="slide-x-reverse-transition"
      mode="out-in">

        <!-- ITEMS -->
        <div 
        v-if="selectedCount === 0"
        key="1"
        class="c-flex-r align-center subheading">

          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
          text
          outlined
          class="mr-2"
          @click="newSale">
            <v-icon>add</v-icon>
            <div class="ml-1 text--text">
              New sale
            </div>
          </v-btn>

        </div>

        <!-- selected count -->
        <div v-if="selectedCount > 0"
        key="2"
        class="c-flex-r align-center subheading">
          <v-btn
          icon
          class=""
          @click="selected = {}">
            <v-icon color="color1">close</v-icon>
          </v-btn>
          <div class="text-sans font-weight-bold">
            <span>&nbsp;{{ selectedCount }}</span>
            selected 
          </div>
          <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
          <span class="icon--text ml-2">|</span>
          <v-btn 
          icon
          @click="onDelete">
            <v-icon>delete_outline</v-icon>
          </v-btn>
          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </transition>

      <v-spacer></v-spacer>

      <div>
        <transition
        name="fade-transition"
        mode="out-in">
          <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
            <span class="grey--text caption">LOADING...</span>&nbsp;
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
          <div v-else key="L2"></div>
        </transition>
      </div>

    </v-row>
    <!-- pagination toolbar -->

    <table class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="15px">
        <col width="15px">
        <col width="15px">
        <col width="15px">
      </colgroup>

      <tr class="unselectable">
        <c-table-header
        title="Sale ID"
        code="id"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Items"
        code="item_count"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Customer"
        code="customer"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Date"
        code="date"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
  
      </tr>

      <tr class="disable-hover">
        <td>
          <v-text-field
          v-model="filters.search.id"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo></v-text-field>
        </td>
        <td>
        </td>
        <td>
          <v-text-field
          v-model="filters.search.customer_name"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo></v-text-field>
        </td>
        <td></td>
      </tr>

      <row
      v-for="(item, i) in items" 
      :key="item.id"
      :item="item"
      :itemsMeta="itemsMeta"
      :selected="selected"
      :searchFilters="filters.search"
      :active="currentIndex === i"
      :currentSelection="item.id === currentSelectedID"
      @click.native="clickRow(item)"
      @checkRow="checkRow(item)"
      ></row>

    </table>


    <!--
    <div 
    v-if="items.length === 0"
    key="a"
    class="pa-4">

      <div class="display-1">
        No results found
      </div>

      <v-card>
        <v-img src="https://cdn.pixabay.com/photo/2017/04/08/22/26/meditation-2214532_1280.jpg">

        </v-img>
      </v-card>
    </div>
    -->

    <!-- THE NEW NO ITEMS BLOCK -->
    <!-- No sales -->
    <v-card v-if="items.length === 0" class="pa-2 ma-4 subheading elevation-0">
      <v-row v-if="searchIsActive" align-center class="backgroundCard pa-4">
        <v-icon>mdi-alert</v-icon>
        <div class="ml-2 mr-2">
          <span>
            No items match your search
          </span>
        </div>
      </v-row>
      <v-row v-else-if="activeFilterCount > 0" align-center class="backgroundCard pa-4">
        <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
        <div class="ml-2 mr-2">
          <v-layout align-center>
            <span>
              No items match your filters
            </span>
            <v-icon large color="red accent-4">search</v-icon>
          </v-layout>

          <div class="caption text--text text--darken-1">
            clear filters
          </div>
        </div>
      </v-row>
      <v-row v-else align-center class="pa-4">
        <img src="@/assets/img/illustrations/package.png" alt="cardboard box" width="36px">
        <div class="ml-2 mr-2">
          <v-layout align-center>
            <span>
              0 sales in process
            </span>
            <v-icon large color="green accent-4">check</v-icon>
          </v-layout>

          <div class="caption text--text text--darken-1">
            Sales in process will be listed here
          </div>
        </div>
      </v-row>
    </v-card>
    <!-- THE NEW NO ITEMS BLOCK -->

    <!-- PAGINATION -->
    <c-pagination
    :page="page"
    :pagination="pagination"
    :filters="filters"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage"
    ></c-pagination>
    <!-- PAGINATION -->
    
  </v-card>
</template>

<script>
import Row from './components/SalesRow'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListRouteBindings'
import CSListItemsPerPage from '@/components/list-server/C-SListItemsPerPage'
import CTableHeader from '@/components/list-server/th'

export default {
  components: {
    Row,
    CSListItemsPerPage,
    CTableHeader
  },
  mixins: [ServerListController, ServerListBindings],
  props: [],
  data () {
    return {
      filters: {
        rowsPerPage: 10,
        sortCol: 'id',
        sortAscending: false,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          batch_number: '',
          customer_name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      page: 0,
      currentSelectedID: null,
      currentIndex: 0,
      isLoading: false,
      itemsMeta: {
        newID: null // this will be set to the newst created row
      }
    }
  },
  methods: {
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$router.push('/sale/' + item.id)
      }
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' sale' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('sales/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    newSale () {
      this.$axios.post('sales/create',
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          this.itemsMeta.newID = response.data.id
          this.page = 0
          this.filters.sortCol = 'id'
          this.filters.sortAscending = false
          Object.keys(this.filters.active).forEach(key => {
            this.filters.active[key] = false
          })
          Object.keys(this.filters.search).forEach(key => {
            this.filters.search[key] = ''
          })
          this.loadAPI()
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/sales?filters=${encodedFilters}&stage=${0}&page=${this.page}`)
          .then(response => {
            var hrend = response.data.execution_time
            // console.log(hrend)
            // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            this.items = rows
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  },
  activated () {
    this.loadAPI()
  }
}
</script>